import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { UpaegService } from '../../services/upaeg.service';
import { CombosService } from '../../services/combos.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {CurpValidator, RfcValidator, NameValidator, CPValidator, MovilValidator} from '../../validators/validator';
import {FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AlertPopComponent} from '../alert-pop/alert-pop.component';
import { ConfirmPopComponent } from '../confirm-pop/confirm-pop.component';

@Component({
  selector: 'app-upaeg-moral',
  templateUrl: './upaeg-moral.component.html',
  styleUrls: ['./upaeg-moral.component.css'],
  providers: [UserService, UpaegService, CombosService]
})
export class UpaegMoralComponent implements OnInit {
  public sessionActive: boolean;
  public message: string;
  public status: string;
  form: FormGroup;
  public redirect = null;

  public estados = [];
  public municipios = [];
  public localidades = [];

  public asentamientos = [];
  public vialidades = [];
  public tiposAso = [];
  public actividadesEco = [];

  public createUpa = true;

  constructor(
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private upaegSerivice: UpaegService,
    private combosSerivice: CombosService,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      idProductor: [null],
      idAsociacion: [null],
      rfc: ['', [Validators.required, RfcValidator]],
      razonSocial: ['', [Validators.required]],
      domFiscal: ['', []],
      idTipoAsociacion: ['', [Validators.required, Validators.minLength(1)]],
      idActiEconomica: ['', [Validators.required, Validators.minLength(1)]],
      noActaConst: ['', [Validators.required]],
      fechaActa: ['', [Validators.required]],
      // tslint:disable-next-line:max-line-length
      nomNotario: ['', [Validators.required,  Validators.pattern(/^[a-z|A-Z|á|é|í|ó|ú|Á|É|Í|Ó|Ú|ñ|Ñ]{1,}[.]{0,1}([\s]{1,1}[a-z|A-Z|á|é|í|ó|ú|Á|É|Í|Ó|Ú|ñ|Ñ]{1,}[.]{0,1})*$/)]],
      numNotario: ['', [Validators.required]],
      idEdo: ['', [Validators.required, Validators.minLength(1)]],
      idMun: ['', [Validators.required, Validators.minLength(1)]],
      idLoc: ['', [Validators.required, Validators.minLength(1)]],
      idAsenta: ['', [Validators.required, Validators.minLength(1)]],
      nomAcenta: ['', [Validators.required]],
      idVialidad: ['', [Validators.required, Validators.minLength(1)]],
      nomVialidad: ['', [Validators.required]],
      noExterior: ['', [Validators.required]],
      noInterior: ['', []],
      codigoPostal: ['', [Validators.required, Validators.maxLength(5), CPValidator ]],
      referencias: ['', []],
      entreVialidades: ['', []],
      nacionalidad: ['', [Validators.required]],
      emailAsociacion: ['', [Validators.required, Validators.email]],
      telefono: [null, [Validators.pattern(/^([0-9]{10,10})$/)]],
      movil: ['', [Validators.required, Validators.pattern(/^([0-9]{10,10})$/)]],
      fechaModAtribu: ['', []],
      objetoSocial: ['', []],
      latitud: ['', [Validators.required]],
      longitud: ['', [Validators.required]],
    });
   }

  ngOnInit() {
    /* VALIDATE SESSION */
    if (this.userService.getToken()){
      this.userService.check_session().subscribe(response => {
        if (response.status) {
        } else {
          this.userService.destroy_session();
          this.router.navigate(['/login']);
        }
      }, error => {
        console.log(error);
        this.userService.destroy_session();
        this.router.navigate(['/login']);
      });
    }else{
      this.userService.destroy_session();
      this.router.navigate(['/login']);
    }
   /* VALIDATE SESSION */
   this.loadCombos();
    this.getParams();
  }

  openDialog(title, text, action): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  loadCombos() {
    this.combosSerivice.getEstados().subscribe(response => {
      this.estados = response;
    }, error => {
      console.log(error);
      this.openDialog('Error', 'Error al obtener los estados', 'Cerrar');
    });

    this.combosSerivice.getAsentamientos().subscribe(response => {
      this.asentamientos = response;
    }, error => {
      console.log(error);
      this.openDialog('Error', 'Error al obtener los asentamientos', 'Cerrar');
    });

    this.combosSerivice.getVialidades().subscribe(response => {
      this.vialidades = response;
    }, error => {
      console.log(error);
      this.openDialog('Error', 'Error al obtener las vialidades', 'Cerrar');
    });

    this.combosSerivice.getAsociaciones().subscribe(response => {
      this.tiposAso = response;
    }, error => {
      console.log(error);
      this.openDialog('Error', 'Error al obtener tipos de asociación', 'Cerrar');
    });

    this.combosSerivice.getActividades().subscribe(response => {
      this.actividadesEco = response;
    }, error => {
      console.log(error);
      this.openDialog('Error', 'Error al obtener actividades', 'Cerrar');
    });
  }

  onSelectEstado() {
    if (this.form.get('idEdo').valid) {
      this.combosSerivice.getMunicipios(this.form.get('idEdo').value).subscribe(response => {
        this.municipios = response;
        if (this.form.get('idEdo').value === '') {
          this.form.get('idMun').setValue('');
          this.form.get('idLoc').setValue('');
        }
      }, error => {
        console.log(error);
        this.openDialog('Error', 'Error al obtener los municipios', 'Cerrar');
      });

    } else {
      this.municipios = [];
      this.form.get('idMun').setValue('');
      this.form.get('idLoc').setValue('');
    }
  }

  onSelectMun() {
    console.log('entrado en mun');
    if (this.form.get('idEdo').valid && this.form.get('idMun').valid) {
      console.log('Valido localidad');
      this.combosSerivice.getLocalidades(this.form.get('idEdo').value, this.form.get('idMun').value).subscribe(response => {
        this.localidades = response;
        if (this.form.get('idMun').value === '') {
          this.form.get('idLoc').setValue('');
        }
      }, error => {
        console.log(error);
        this.openDialog('Error', 'Error al obtener las localidades', 'Cerrar');
      });
    } else {
      this.localidades = [];
      this.form.get('idLoc').setValue('');
    }
  }

  openDialogRedirect(title, text, action): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.router.navigate(['/misupaegs']);
    });
  }

  dialogRedirect(title, text, action, direction): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.router.navigate(['/' + direction]);
    });
  }

  confirmCrearUpaeg() {
    const dialogRef = this.dialog.open(ConfirmPopComponent, {
      width: '40%',
      data: {
        titulo: 'Atención',
        // tslint:disable-next-line:max-line-length
        texto: 'Esta usted a punto de registrar una unidad de producción, esta acción vinculará su unidad de producción (persona física) como representante legal de la asociación, esta acción no podrá ser modificada, ¿Desea continuar con el registro de la unidad de producción?',
        confirm: 'Registrar unidad de producción',
        cancel: 'Cancelar'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.upaegSerivice.saveUpaegMoral(this.form.value).subscribe(response => {
          console.log(response);
          if (response.status) {
            if (this.redirect === null) {
              this.openDialogRedirect('Información guardada', response.message, 'Cerrar');
            } else {
              this.dialogRedirect('Información guardada', response.message, 'Cerrar', this.redirect);
            }
          } else {
            this.openDialog('Error', response.message, 'Cerrar');
          }
        }, error => {
            console.log(error);
            this.openDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
        });
      }
    });

  }

  onSubmit(formulario) {
    if (this.createUpa) {
      this.confirmCrearUpaeg();
    } else {
      this.upaegSerivice.saveUpaegMoral(this.form.value).subscribe(response => {
        console.log(response);
        if (response.status) {
          this.openDialog('Información guardada', response.message, 'Cerrar');
        } else {
          this.openDialog('Error', response.message, 'Cerrar');
        }
      }, error => {
          console.log(error);
          this.openDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
      });
    }
  }

  getEspecificUpaegInfo(idUpaeg) {
    this.upaegSerivice.getUpaegMoral(idUpaeg).subscribe(response => {
      console.log(response);
      if (response.status) {
        response.data.forEach(upaeg => {

          let fechaActa = null;
          if (upaeg.fecha_acta !== '' && upaeg.fecha_acta !== null) {
            fechaActa = new Date(upaeg.fecha_acta.replace(/-/g, '\/'));
          }
          let fechaModAtrib = null;
          if (upaeg.fecha_ult_mod_atrib !== '' && upaeg.fecha_ult_mod_atrib !== null) {
            fechaModAtrib = new Date(upaeg.fecha_ult_mod_atrib.replace(/-/g, '\/'));
          }
          // let fechaModAtrib = new Date(upaeg.fecha_ult_mod_atrib.replace(/-/g, '\/'));
          this.form.get('idProductor').setValue(upaeg.id_productor);
          this.form.get('idAsociacion').setValue(upaeg.id_asociacion);
          this.form.get('rfc').setValue(upaeg.rfc_asociacion);
          this.form.get('rfc').disable();
          this.form.get('razonSocial').setValue(upaeg.nom_asociacion);
          this.form.get('razonSocial').disable();
          this.form.get('domFiscal').setValue(upaeg.dom_fiscal);
          this.form.get('idTipoAsociacion').setValue(upaeg.id_tipo_asociacion);
          this.form.get('idActiEconomica').setValue(upaeg.id_actividad_economica);
          this.form.get('noActaConst').setValue(upaeg.no_acta_constitutiva);
          this.form.get('fechaActa').setValue(fechaActa);
          this.form.get('nomNotario').setValue(upaeg.nom_notario);
          this.form.get('numNotario').setValue(upaeg.no_notario);
          this.form.get('idEdo').setValue(upaeg.id_edo);
          this.form.get('idMun').setValue(upaeg.id_mun);
          this.onSelectEstado();
          this.form.get('idLoc').setValue(upaeg.id_loc);
          this.onSelectMun();
          this.form.get('idAsenta').setValue(upaeg.id_tipo_asentamiento);
          this.form.get('nomAcenta').setValue(upaeg.nom_asentamiento);
          this.form.get('idVialidad').setValue(upaeg.id_tipo_vialidad);
          this.form.get('nomVialidad').setValue(upaeg.nom_vialidad);
          this.form.get('noExterior').setValue(upaeg.num_ext);
          this.form.get('noInterior').setValue(upaeg.num_int);
          this.form.get('codigoPostal').setValue(upaeg.cp);
          this.form.get('referencias').setValue(upaeg.referencias);
          this.form.get('entreVialidades').setValue(upaeg.entre_vialidades);
          this.form.get('nacionalidad').setValue(upaeg.nacionalidad);
          this.form.get('emailAsociacion').setValue(upaeg.correo_asociacion);
          this.form.get('telefono').setValue(upaeg.telefono_asociacion);
          this.form.get('movil').setValue(upaeg.movil_contacto);
          this.form.get('fechaModAtribu').setValue(fechaModAtrib);
          this.form.get('objetoSocial').setValue(upaeg.objeto_social);

          console.log(this.form.value);
        });


      } else {
        this.openDialog('Error', response.message, 'Cerrar');
      }
    }, error => {
          console.log(error);
          this.openDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
    });

  }

  getParams() {
    this.route.params.subscribe(params => {
      if (params.id) {
        let parametro = params.id;
        if (isNaN(parametro)) {
          this.form.get('rfc').setValue(parametro);
          let redirect = params.from;
          this.redirect =    redirect;
          console.log('Posible CURP');
        } else {
          console.log('Editando upaeg');
          this.createUpa = false;
          this.getEspecificUpaegInfo(parametro);
        }
      }
    });

  }

  setCoords($event){
    console.log($event);
    this.form.get('latitud').setValue($event.lat);
    this.form.get('longitud').setValue($event.lng);
  }

}
